export default {

	vacancy: {
		1: 'Full time',
		2: 'Part time',
		3: 'Apprenticeship',
		4: 'Contract'
	},

	error: {
		validation: 1
	},
	
	platform: {
		web: 1,
		twitter: 3,
		facebook: 2
	},

    sort: {
        suggested: 'suggested',
        distance: 'distance',
        reviews: 'reviews',
        rating: 'rating'
    },

    transition: {
        search: 1,
        text: 2
    },

    price: {
        section: 1,
        cost: 2
    },

    tab: {
        price: 1,
        booking: 2
    },
    
    banner: {
        gallery: 1,
        upload: 2
    },

	context: {
		any: 0,
		customer: 1,
		business: 2
	},

	plan: {
		free: 1,
		monthly: 2,
		yearly: 3
	}

}